var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavoriteOutlined(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.807 5.40351C11.7193 3.94737 9.96491 3 8 3C4.68421 3 2 5.68421 2 9C2 15.0702 6.7193 18.9825 9.45614 20.7193C11.1404 21.807 12.8596 21.807 14.5439 20.7193C17.2807 18.9825 22 15.0702 22 9C22 5.68421 19.3158 3 16 3C14.0351 3 12.2807 3.94737 11.193 5.40351C11.0702 5.5614 11 5.77193 11 6C11 6.54386 11.4561 7 12 7C12.3333 7 12.614 6.8421 12.807 6.59649C13.5789 5.5614 14.614 5 16 5C18.3333 5 20 6.66667 20 9C20 14.0877 16.0526 17.386 13.4561 19.0351C12.3509 19.7544 11.6491 19.7544 10.5439 19.0351C7.94737 17.386 4 14.0877 4 9C4 6.66667 5.66667 5 8 5C9.38596 5 10.4211 5.5614 11.193 6.59649C11.386 6.8421 11.6667 7 12 7C12.5439 7 13 6.54386 13 6C13 5.77193 12.9298 5.5614 12.807 5.40351Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteOutlined);
export default __webpack_public_path__ + "static/media/favorite_outlined.597daece.svg";
export { ForwardRef as ReactComponent };